<template>
  <div>
    <c-modal
      v-if="showModal"
      title="Exhibit Content"
      size="md"
      @close="closeModal"
    >
      <div class="modal-body">
        <div v-if="isFetching">
          <c-spinner />
        </div>

        <div v-else>
          <div
            v-for="(category, index) in categories"
            :key="index"
            class="category-materials"
          >
            <accordion
              :title="category.name"
              :key="`accordion-${index}`"
              :isOpen="openedIndex === index"
              @toggle="toggle(index)"
            >
              <material-list
                :materials="category.materials"
              />
            </accordion>
          </div>

          <div class="no-category-materials">
            <material-list
              :materials="materials"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <c-button
          theme="default"
          size="md"
          icon="fa-close"
          @click="closeModal"
          uppercase
          fill
        >Close</c-button>
      </div>
    </c-modal>
  </div>
</template>

<script>
import sponsorsAPI from "../../../api/sponsorsAPI";
import Accordion from "../../../components/ui/Accordion/index";
import MaterialList from "./materials-list";

export default {
  components: {
    MaterialList,
    Accordion
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.fetchMaterials();
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,
      categories: [],
      materials: [],
      isFetching: false,
      openedIndex: null
    }
  },
  methods: {
    toggle(index) {
      this.openedIndex = this.openedIndex === index ? null : index;
    },

    fetchMaterials() {
      this.isFetching = true;

      sponsorsAPI.fetchExhibitorMaterials(this.attendeeId, this.sponsorId)
        .then((res) => {
          this.categories = res.data?.data?.categories;
          this.categories.forEach(item => {
            item.materials = this.modifyMaterials(item.materials);
          });

          this.materials = this.modifyMaterials(res.data?.data?.materials);
        })
        .finally(() => {
          this.isFetching = false;
        })
    },

    modifyMaterials(materials) {
      materials.forEach(item => {
        switch(item.icon_font_code) {
          case 'p':
            item.icon = 'fa-file-pdf';
            item.color = 'text-danger';
            break;
          case 'w':
            item.icon = 'fa-file-word';
            item.color = 'text-primary';
            break;
          case 'x':
            item.icon = 'fa-file-excel';
            item.color = 'text-success';
            break;
          case 'i':
            item.icon = 'fa-file-image';
            item.color = 'text-info';
            break;
          case 'v':
            item.icon = 'fa-file-video';
            item.color = 'text-info';
            break;
          case 'a':
            item.icon = 'fa-file-audio';
            item.color = 'text-info';
            break;
          case 'z':
            item.icon = 'fa-file-zipper';
            item.color = 'text-warning';
            break;
          default:
            item.icon = 'fa-file';
            item.color = 'text-primary';
        }
      });

      return materials;
    },

    closeModal() {
      this.$emit('update:showModal', false);
    }
  }
}
</script>

<style lang="scss" scoped>
.no-category-materials {
  padding: 15px 15px;
}
</style>
